export var uiEllipsisH = [
    'M9.01 8C9.01 8.55 8.56 9 8.01 9C7.46 9 7.01 8.55 7.01 8C7.01 7.45 7.46 7 8.01 7C8.56 7 9.01 7.45 9.01 8ZM11.76 7C11.21 7 10.76 7.45 10.76 8C10.76 8.55 11.21 9 11.76 9C12.31 9 12.76 8.55 12.76 8C12.76 7.45 12.31 7 11.76 7ZM4.26 7C3.71 7 3.26 7.45 3.26 8C3.26 8.55 3.71 9 4.26 9C4.81 9 5.26 8.55 5.26 8C5.26 7.45 4.81 7 4.26 7Z',
];
